const SERVER_URL = 
  "https://amberwoodre-backend-nodejs-cpmn6gngia-wl.a.run.app/"
  // "http://192.168.29.223:8080/"
  const IMAGE_URL = 
  "https://storage.googleapis.com/cdn-amberwoodre/"
module.exports = {
  SERVER_URL,IMAGE_URL
};